import { render, staticRenderFns } from "./NoProfileSelected.vue?vue&type=template&id=8025f57a&scoped=true&"
import script from "./NoProfileSelected.vue?vue&type=script&lang=js&"
export * from "./NoProfileSelected.vue?vue&type=script&lang=js&"
import style0 from "./NoProfileSelected.vue?vue&type=style&index=0&id=8025f57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8025f57a",
  null
  
)

export default component.exports